import React from "react";

import { Image } from "rebass";

// ------------------------------------------------------------------------

const Logo = ({ ...rest }) => <Image width="44px" height="44px" {...rest} />;

export default Logo;
